import type { SbBlokData } from "@storyblok/js";
import { storyblokEditable } from "@storyblok/js";

import BlokWrap from "@/components/ui/BlokWrap";
import type { ButtonStoryblok } from "@/generated/sb/sb-types";

import Button from "@/components/ui/Button";

import { getLink } from "@frend-digital/storyblok";
import styles from "./button.module.css";
const ButtonBlok = ({ blok }: { blok: ButtonStoryblok }) => {
  const { link: links, align } = blok;

  const alignment = () => {
    if (align === "center") {
      return "center";
    }
    if (align === "right") {
      return "flex-end";
    }
    return "flex-start";
  };

  const link = links?.[0];
  const href = link?.link ? getLink(link.link)?.href : undefined;

  return (
    <BlokWrap
      {...storyblokEditable(blok as unknown as SbBlokData)}
      data-layout={"page"}
      className={styles.wrapper}
      style={{
        alignItems: alignment(),
      }}
    >
      {link && href && (
        <>
          <Button href={href}>{link.text}</Button>
        </>
      )}
    </BlokWrap>
  );
};

export default ButtonBlok;
